import { RefCallback, createContext } from 'react';

/**
 * @internal
 */
export interface GridPlotContextProps {
  width: number;
  height: number;
  ref: RefCallback<HTMLDivElement> | null | undefined;
}

export const initialValue: GridPlotContextProps = {
  width: 0,
  height: 0,
  ref: null,
};
export const GridPlotContext =
  createContext<GridPlotContextProps>(initialValue);

GridPlotContext['displayName'] = 'GridPlotContext';
